import { ARTICLE_NUMBER } from '../constants';

const defaultState = {
    currentArticleNumber: null,
};

export const product = (state = defaultState, action) => {
    switch (action.type) {
        case ARTICLE_NUMBER:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};
